import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LogoImage from '@/assets/images/logo.png?as=webp&width=132&height=132';
import ROUTE_NAMES from '@/constants/routeNames';

type Props = {
  width?: number;
  height?: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'LogoComponent',
  props: {
    width: { default: 132 },
    height: { default: 132 }
  },
  setup(__props: any) {

// @TODO: After upgrade to Webpack5/Vite, create base component for images to convert images to webp/avif based on path


return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: _unref(ROUTE_NAMES).HOME }
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_img, {
        src: _unref(LogoImage),
        class: "pointer",
        alt: "Szlachetna Paczka",
        "aspect-ratio": "1",
        position: "center",
        width: _ctx.width,
        height: _ctx.height
      }, null, 8, ["src", "width", "height"])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})